import { useLocationLegacy as useLocation } from '@leagueplatform/routing';
import { useScrollTopOnLocationChange } from '@leagueplatform/web-common';
import { APP_NAV_DEFAULT_HEIGHT } from 'components/header-nav/navbar/nav.constants';

interface UseBasePageProps {
  isPrivatePage?: boolean;
}

interface UseBasePageReturn {
  // Data
  pathname: string;

  // Computed values
  shouldShowNavBar: boolean;
  shouldShowFooter: boolean;
  mainStyles: any;

  // Actions
  initializePage: () => void;
}

export const useBasePage = ({
  isPrivatePage = true,
}: UseBasePageProps): UseBasePageReturn => {
  useScrollTopOnLocationChange();
  const { pathname } = useLocation();

  const shouldShowNavBar = isPrivatePage;
  const shouldShowFooter = isPrivatePage && !pathname.startsWith('/messages/');

  const mainStyles = {
    overflowX: 'hidden',
    position: 'relative',
    flex: '1',
    minHeight: `calc(100vh - ${APP_NAV_DEFAULT_HEIGHT}px)`,
    'a[href^="tel:"]': {
      cursor: 'default',
      pointerEvents: 'none',
      color: '$textPrimary',
      '&:hover': {
        color: '$textPrimary',
        textDecoration: 'none',
      },
    },
    ...(pathname.startsWith('/benefits')
      ? {
          // Specific styles for benefits pages
          '.cc-page-header-background::before': {
            height: '19970px',
          },
        }
      : {}),
    ...(pathname.startsWith('/home') || pathname.startsWith('/get-care')
      ? {
          // Apply object-fit: contain to all images on /home and /get-care pages
          img: {
            objectFit: 'contain',
          },
        }
      : {}),
  };

  const initializePage = () => {
    // Any additional page initialization logic can go here
  };

  return {
    // Data
    pathname,

    // Computed values
    shouldShowNavBar,
    shouldShowFooter,
    mainStyles,

    // Actions
    initializePage,
  };
};
